<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t('screener.monetization.all_sales.title') }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t('screener.monetization.all_sales.subtitle')
        }}</span>
      </div>
    </v-card-title>
    <v-card-text class="px-0">
      <v-layout row wrap class="pa-3">
        <v-flex xs12 sm6 md6>
          <v-text-field
            append-outer-icon="search"
            v-model="search"
            :placeholder="$t('rms.field.sales_search')"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6 pl-2>
          <v-select
                v-model="filters.purchase_type"
                :items="DEFINES.MONETIZATION.PURCHASE_TYPES_AS_FILTER"
                :label="$t('screener.table.header.purchase_type')"
                item-text="text"
                item-value="value"
                @input="getPurchasesFromApi"
                class="pr-3 d-inline-block"
              ></v-select>
        </v-flex>
        <v-flex xs12 sm12 md12 pl-2>
          <v-layout row wrap class="text-xs-right">
            <!-- From date -->
            <v-flex xs12 sm12 md4 pr-2>
              <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDate"
                    label="Start Date"
                    readonly
                    color="primary"
                    v-on="on"
                    clearable
                    class="mr-0 pr-0"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  color="primary"
                  :show-current="new Date().toISOString().substr(0, 10)"
                  @input="fromDateMenu = false"
                ></v-date-picker> </v-menu
            ></v-flex>
            <!-- To date -->
            <v-flex xs12 sm12 md4 pl-2>
              <v-menu
                class="d-flex"
                v-model="toDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDate"
                    label="End Date"
                    readonly
                    color="primary"
                    v-on="on"
                    clearable
                    :rules="
                      fromDate
                        ? [
                            rules.greaterThanDate(
                              fromDate,
                              toDate
                            ),
                          ]
                        : []
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  color="primary"
                  :show-current="new Date().toISOString().substr(0, 10)"
                  @input="toDateMenu = false"
                ></v-date-picker> </v-menu
            ></v-flex>
            <v-flex xs12 sm12 md3>
              <v-btn @click="exportAllPurchases" color="primary" class="mx-0">
                <v-icon small class="pr-1"
                  >$vuetify.icons.rms_media_download</v-icon
                >
                {{ $t('company.consumer.details.export') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="table_headers"
        :loading="loading"
        :items="purchases"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="id"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip top v-if="props.header.tooltip" color="greyDarken1">
            <template v-slot:activator="{on}">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span
              class="white--text body-1"
              v-html="props.header.tooltip"
            ></span>
          </v-tooltip>
          <span v-else>{{ props.header.text }}</span>
        </template>
        <template v-slot:items="props">
          <tr @click.stop="viewPurchase(props.item.id)" style="cursor: pointer">
            <td class="body-2">
              {{ props.item.consumer_email }}
            </td>
            <td>
              <div v-if="props.item.pricing">
                <!-- <v-tooltip top color="greyDarken1"> -->
                <!-- <template v-if="props.item.pricing" v-slot:activator="{on}">
                    <span v-on="on">{{
                      props.item.pricing.name | truncate
                    }}</span> -->
                <!-- </template> -->
                <span class="body-1">{{ props.item.pricing.name }}</span>
                <!-- </v-tooltip> -->
              </div>
              <div v-else>NA</div>
            </td>
            <td>
              <div v-if="props.item.in_venue">
                <span class="body-1">{{
                  props.item.in_venue.event_title
                }}</span>
                <!-- </v-tooltip> -->
              </div>
              <div v-else>NA</div>
            </td>
            <td>
              {{ DEFINES.MONETIZATION.PURCHASE_TYPE[props.item.purchase_type] }}
            </td>
            <td>
              <span v-if="props.item.pricing">
                {{ props.item.pricing.screening_ids.length }}
              </span>
              <span
                v-else-if="
                  props.item.purchase_type ==
                    DEFINES.MONETIZATION.PRICING_TYPE['PHYSICAL_PURCHASE']
                "
              >
                1
              </span>
            </td>
            <td>
              {{ props.item.coupon_code ? props.item.coupon_code : '--' }}
            </td>
            <td>
              {{
                props.item.discount_percentage
                  ? props.item.discount_percentage
                  : 0
              }}
            </td>
            <td>{{ props.item.currency }}</td>
            <td>
              <span v-if="props.item.total_amount > 0" class="green--text"
                ><strong>+&nbsp;</strong></span
              >
              {{ getCurrencySymbol(props.item.currency) }}&nbsp;{{
                props.item.total_amount
              }}
            </td>
            <td>
              <span v-if="props.item.gateway_fee > 0" class="red--text"
                ><strong>-&nbsp;</strong></span
              >
              {{ getCurrencySymbol(props.item.currency) }}&nbsp;{{
                props.item.gateway_fee ? props.item.gateway_fee : 0
              }}
            </td>
            <td>
              <span v-if="props.item.system_share > 0" class="red--text"
                ><strong>-&nbsp;</strong></span
              >
              {{ getCurrencySymbol(props.item.currency) }}&nbsp;{{
                props.item.system_share ? props.item.system_share : '0.00'
              }}
            </td>
            <td>
              <span v-if="props.item.refunded_amount > 0" class="red--text"
                ><strong>-&nbsp;</strong></span
              >
              {{ getCurrencySymbol(props.item.currency) }}&nbsp;{{
                props.item.refunded_amount
              }}
            </td>
            <td>
              {{ getCurrencySymbol(props.item.currency) }}&nbsp;{{
                getTotalEarnedAmount(props.item)
              }}
            </td>
            <td>
              <v-chip v-if="props.item.is_paid" color="green" dark small>{{
                $t('screener.status.paid')
              }}</v-chip>
              <v-chip v-if="props.item.is_refunded" color="orange" dark small>{{
                $t('screener.status.refunded')
              }}</v-chip>
            </td>
            <td>{{ fmtTime(props.item.created_at) }}</td>
            <td>
              <v-tooltip slot="append" top color="white">
                <v-btn
                  slot="activator"
                  icon
                  small
                  dark
                  @click.stop="viewPurchase(props.item.id)"
                >
                  <v-icon color="secondary"
                    >$vuetify.icons.rms_visibility</v-icon
                  >
                </v-btn>
                <span class="greyDarken3--text body-1">{{
                  $t('company.consumer.details.form.btn.show.details')
                }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import DEFINES from '@/defines';
import {utcToTz, tzToUtc, getCurrencySymbol} from '@/helper';
import i18n from '@/i18n';
import rules from "@/validation";
// data
const data = {
  rules,
  table_headers: [
    {
      text: i18n.t('screener.table.header.participant'),
      sortable: false,
      align: 'left',
      value: 'consumer_email',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.pricing_plan'),
      sortable: false,
      align: 'left',
      value: 'name',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.in_venue_event'),
      sortable: false,
      align: 'left',
      value: 'event_title',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.purchase_type'),
      sortable: true,
      align: 'left',
      value: 'purchase_type',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.screenings'),
      sortable: false,
      align: 'left',
      value: 'screenings',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.coupon'),
      sortable: false,
      align: 'left',
      value: 'coupon_code',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.discount'),
      sortable: false,
      align: 'left',
      value: 'discount_percentage',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.currency'),
      sortable: false,
      align: 'left',
      value: 'currency',
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.total_amount'),
      sortable: true,
      align: 'left',
      value: 'total_amount',
      tooltip: i18n.t('screener.table.header.total_amount.tooltip'),
    },
    {
      text: i18n.t('screener.table.header.gateway_fees'),
      align: 'left',
      sortable: true,
      value: 'gateway_fee',
      tooltip: i18n.t('screener.table.header.gateway_fees.tooltip'),
    },
    {
      text: i18n.t('screener.system_share.title'),
      sortable: true,
      align: 'left',
      value: 'system_share',
      tooltip: i18n.t('screener.system_share.tooltip'),
    },
    {
      text: i18n.t('screener.table.header.refunded_amount'),
      sortable: true,
      align: 'left',
      value: 'refunded_amount',
      tooltip: i18n.t('screener.table.header.refunded_amount.tooltip'),
    },
    {
      text: i18n.t('screener.table.header.earned_amount'),
      align: 'left',
      value: 'amount',
      sortable: false,
      tooltip: i18n.t('screener.monetization.earned_amount.tooltip'),
    },
    {
      text: i18n.t('screener.table.header.status'),
      align: 'left',
      value: 'status',
      sortable: false,
      tooltip: '',
    },
    {
      text: i18n.t('screener.table.header.created_at'),
      align: 'left',
      value: 'created_at',
      sortable: true,
      tooltip: '',
    },
  ],
  rowsPerPageItems: [1, 5, 10, 25, 50, 100],
  pagination: {
    sortBy: 'created_at',
    descending: true,
    page: 1,
    rowsPerPage: 10,
  },
  search: '',
  loading: false,
  total: null,
  filters: {
    purchase_type: null,
  },
  fromDateMenu: false,
  toDateMenu: false,
  fromDate: null,
  toDate: null
};

// Computed
const computed = {
  ...mapState({
    purchases: (state) => state.monetization.purchases,
  }),
  ...mapGetters('company', {
    timezone: 'getSelectedCompanyTimezone',
  }),
};

// Methods
const methods = {
  applySearch() {
    if (this.search.length) this.getPurchasesFromApi();
  },
  clearSearch() {
    this.search = '';
    this.getPurchasesFromApi();
  },
  getTotalEarnedAmount(purchase) {
    if (purchase) {
      var earned_amount =
        purchase.total_amount -
        purchase.gateway_fee -
        purchase.refunded_amount -
        purchase.system_share;
      return earned_amount ? earned_amount.toFixed(2) : 0;
    }
  },
  getCurrencySymbol(currency) {
    return getCurrencySymbol(currency);
  },
  // convert utc to comapny timezone
  fmtTime(input) {
    return utcToTz(input, this.timezone, 'Do MMM YYYY, h:mm a');
  },
  async getPurchasesFromApi() {
    try {
      this.loading = true;
      // Pagination
      const {sortBy, descending, page, rowsPerPage} = this.pagination;
      var offset = this.getPaginationOffset(rowsPerPage, page);
      // Payload
      let payload = {
        offset: offset,
        limit: rowsPerPage,
        sort: sortBy,
        sorting_order: descending,
        search: this.search,
        filters: this.filters,
      };

      var response = await this.$store.dispatch(
        'monetization/listPurchases',
        payload,
      );
      this.total = response.purchases.total;

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.$store.dispatch('app/showMessage', {
        message: error.message,
        color: 'error',
      });
    }
  },
  viewPurchase(purchase_id) {
    this.$router.push({
      name: 'purchase.detail',
      params: {
        purchase_id: purchase_id,
      },
    });
  },
  getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
  async exportAllPurchases() {
    await this.$store
      .dispatch('monetization/exportAllPurchases',
              { 'start_date':this.fromDate,
                'end_date':this.toDate,
              }
      )
      .then((response) => {
        this.$store.dispatch('app/showMessage', {
          message: i18n.t('screener.purchases.report_email.msg'),
          color: 'success',
        });
      })
      .catch((error) => {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      });
  },
};

export default {
  name: 'PurchaseList',
  data: function() {
    return data;
  },
  computed: computed,
  watch: {
    pagination: {
      handler: 'getPurchasesFromApi',
      deep: true,
    },
  },
  mounted() {
    this.getPurchasesFromApi();
  },
  methods: methods,
};
</script>

<style></style>
